<template>
  <div id="app">
    <Head />
    <div class="box">
      <p class="get-name" v-if="username">
        您好,{{username}}
        <span class="logout" @click.stop="logout">[退出]</span>
      </p>
      <span class="login" @click="openAndClose('Login')" v-else>您好,请登录</span>
      <span class="myprize" @click="handleOpenMyprize">我的奖品>></span>
    </div>
    <Draw :awardChance="awardChance" @giftmsg="judgeBingo" />
    <!-- <Libao /> -->
    <Rule />
    <Bingo :show="openBingo" :gift="gifts" @changelogin="openAndClose('Bingo')" />
    <Login :show="openLogin" @changelogin="openAndClose('Login')" @getusername="getusername" />
    <Myprize
      :show="openMyPrize"
      :goodslist="goodslist"
      @changemyprize="openAndClose('Prize')"
      @complete="judgeBingo"
    />
  </div>
</template>

<script>
import Head from "./components/Head";
import Draw from "./components/Draw";
// import Libao from "./components/Libao";
import Rule from "./components/Rule";
import Login from "./components/Login";
import Myprize from "./components/Myprize";
import Bingo from "./components/Bingo";

import { logout, Login as loginUrl, is_login, my_prize } from "./config";
import qs from "qs";
export default {
  name: "app",
  components: {
    Head,
    Draw,
    // Libao,
    Rule,
    Login,
    Myprize,
    Bingo
  },
  data: () => ({
    openLogin: false,
    openMyPrize: false,
    openBingo: false,
    username: "",
    goodslist: [],
    awardChance: 0,
    gifts: {}
  }),
  created() {
    let uid = this.getParam("uid");
    let token = this.getParam("token");
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "post",
      transformRequest: [
        function(data) {
          // 对 data 进行任意转换处理
          return qs.stringify(data);
        }
      ],
      url: loginUrl,
      data: {
        uid: uid ? uid : "",
        token: token ? token : ""
      }
    }).then(res => {
      let { data } = res;
      if (data.code == 0) {
        this.username = data.data.username;
        this.awardChance = data.data.drawTimes;
      } else {
        this.checkLogin();
      }
    });
  },
  methods: {
    //领取奖品
    // getPrize(item){

    // },
    //判断是否中奖
    judgeBingo(item) {
      if (item.from === "prize") {
        this.openAndClose("Prize");
      }
      if (item.type !== "NONE") {
        this.gifts = item;
        this.openAndClose("Bingo");
        return;
      }
      this.$toast({
        message: "再接再厉哦!",
        duration: 1000,
        position: "bottom"
      });
    },
    //我的奖品列表
    handleOpenMyprize() {
      this.$axios({
        method: "get",
        withCredentials: true,
        crossDomain: true,
        url: my_prize
      }).then(res => {
        let { data } = res;
        if (data.code !== 0) {
          this.$toast({
            message: "请登录",
            duration: 1000,
            position: "bottom"
          });
          return;
        }
        this.goodslist = data.data.sort(
          (a, b) => Date.parse(b.ctime) - Date.parse(a.ctime)
        );
        this.openAndClose("Prize");
      });
    },
    //判断是否登陆
    checkLogin() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: is_login
      }).then(res => {
        let { data } = res;
        if (data.code === -1) {
          this.$toast({
            message: "请登录",
            duration: 1000,
            position: "bottom"
          });
          return;
        }
        this.username = data.data.username;
        this.awardChance = data.data.drawTimes;
      });
    },
    // 控制开关
    openAndClose(type) {
      switch (type) {
        // 登陆窗口
        case "Login":
          this.openLogin = !this.openLogin;
          break;
        // 我的奖品窗口
        case "Prize":
          this.openMyPrize = !this.openMyPrize;
          break;
        case "Bingo":
          this.openBingo = !this.openBingo;
          break;
        default:
          break;
      }
    },
    //登陆成功后获得用户名
    getusername(obj) {
      if (obj) {
        this.username = obj.username;
        this.awardChance = obj.drawTimes;
      }
    },
    //退出登陆
    async logout() {
      let that = this;
      let res = await this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: logout
      });
      let { data } = res;
      if (data.code === -1) {
        this.$toast({
          message: "登出失败",
          type: "fail",
          duration: 600,
          position: "bottom"
        });
        return;
      }
      this.$toast({
        message: "登出成功",
        duration: 600,
        type: "success",
        onOpened() {
          that.username = "";
          that.awardChance = 0;
        }
      });
    },
    //获取url share字段
    getParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
};
</script>

<style lang="scss">
#app {
  max-width: 750px;
  margin: 0 auto;
  background-color: #0c2148;
  .box {
    padding: 0 35px;
    height: 80px;
    box-sizing: border-box;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      cursor: pointer;
    }
    .get-name {
      color: #fff;
    }
    .login {
      color: #eabd22;
    }
    .myprize {
      color: #fff;
    }
  }
}
</style>
